
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/datatable/datatable.js'
      import type { DdsSortingChangeEvent } from '../../events/events'
import type { DdsSelectionChangeEvent } from '../../events/events'
import type { DdsPaginationChangeEvent } from '../../events/events'
import type { DdsRowClickEvent } from '../../events/events'
      export type { DdsSortingChangeEvent } from '../../events/events'
export type { DdsSelectionChangeEvent } from '../../events/events'
export type { DdsPaginationChangeEvent } from '../../events/events'
export type { DdsRowClickEvent } from '../../events/events'

      const tagName = 'dap-ds-datatable'

      /**
 * `dap-ds-datatable`
 * @summary A data table is a component that displays data in a tabular format.
 * @element dap-ds-datatable
 * @title - Data table
 * @generic T
 *
 * @event {{ sorting: SortingState }} dds-sorting-change - Fired when the sorting of the table changes.
 * @event {{ selection: RowSelectionState }} dds-selection-change - Fired when the selection of the table changes.
 * @event {{ pagination: PaginationState }} dds-pagination-change - Fired when the pagination of the table changes.
 * @event {{ row: Row<T> }} dds-row-click - Fired when a row is clicked.
 *
 * @slot loading - The loading content of the table.
 * @slot empty - The empty content of the table.
 *
 * @csspart base - The main table container.
 * @csspart header - The header of the table.
 * @csspart header-row - The header row of the table.
 * @csspart header-cell - All cells of the header.
 * @csspart body - The body of the table.
 * @csspart empty - The empty content of the table.
 * @csspart loading - The loading content of the table.
 * @csspart row - All rows of the table.
 * @csspart cell - All cells of the table.
 * @csspart pager - The pager of the table.
 * @csspart pager-base - The base of the pager.
 * @csspart pager-first - The first button of the pager.
 * @csspart pager-previous - The previous button of the pager.
 * @csspart pager-next - The next button of the pager.
 * @csspart pager-last - The last button of the pager.
 * @csspart pager-page-size-select - The page size select of the pager.
 *
 * @cssproperty --dds-datatable-bg-color - Background color of the table. (default: var(--dds-background-neutral-subtle)).
 * @cssproperty --dds-datatable-border-color - Border color of the table cells. (default: var(--dds-border-neutral-divider))
 * @cssproperty --dds-datatable-header-bg-color - Background color of the table header. (default: var(--dds-background-neutral-subtle))
 * @cssproperty --dds-datatable-header-text-color - Text color of the table header. (default: var(--dds-text-neutral-strong))
 * @cssproperty --dds-datatable-row-hover-bg-color - Background color of hovered rows. (default: var(--dds-background-brand-strong))
 * @cssproperty --dds-datatable-row-selected-bg-color - Background color of selected rows. (default: var(--dds-background-brand-strong))
 * @cssproperty --dds-datatable-cell-padding - Padding of table cells. (default: var(--dds-spacing-200))
 * @cssproperty --dds-datatable-header-padding - Padding of header cells. (default: var(--dds-spacing-200))
 * @cssproperty --dds-datatable-last-column-padding - Padding of the last column. (default: var(--dds-spacing-500))
 * @cssproperty --dds-datatable-first-column-padding - Padding of the first column. (default: var(--dds-spacing-500))
 * @cssproperty --dds-datatable-border-width - Width of table borders. (default: var(--dds-border-width-base))
 * @cssproperty --dds-datatable-outer-border-width - Width of the outer container border only. (default: var(--dds-datatable-border-width))
 * @cssproperty --dds-datatable-header-border-width - Width of the header row bottom border only. (default: var(--dds-datatable-border-width))
 * @cssproperty --dds-datatable-row-border-width - Width of the row (body cell) bottom borders only. (default: var(--dds-datatable-border-width))
 * @cssproperty --dds-datatable-stripe-color - Background color for striped rows. (default: var(--dds-background-neutral-base))
 * @cssproperty --dds-datatable-border-radius - Border radius of the table. (default: var(--dds-radius-base))
 * @cssproperty --dds-datatable-shadow - Box shadow of the table. (default: none)
 * @cssproperty --dds-datatable-transition-duration - Duration of hover/selection transitions. (default: 0.2s)
 * @cssproperty --dds-datatable-z-index - Z-index of the table. (default: 1)
 * @cssproperty --dds-datatable-min-height - Minimum height of the table. (default: auto)
 * @cssproperty --dds-datatable-max-height - Maximum height of the table. (default: none)
 * @cssproperty --dds-datatable-overflow-x - Horizontal overflow behavior. (default: auto)
 * @cssproperty --dds-datatable-overflow-y - Vertical overflow behavior. (default: auto)
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsSortingChange: 'dds-sorting-change' as EventName<DdsSortingChangeEvent>,
onDdsSelectionChange: 'dds-selection-change' as EventName<DdsSelectionChangeEvent>,
onDdsPaginationChange: 'dds-pagination-change' as EventName<DdsPaginationChangeEvent>,
onDdsRowClick: 'dds-row-click' as EventName<DdsRowClickEvent>
        },
        displayName: "DapDSDataTable"
      })

      export default reactWrapper
    